import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import YearSelect from '../YearSelect';

class Achievements extends Component {
  constructor(props) {
    super(props);

    const list = props.list.map(a => ({
      title: a.title,
      year: a.year,
    }));

    this.state = {
      list,
      edit: false,
      index: undefined,
      error: undefined,
      showForm: false,
    };

    this.props.onChange(list);
  }

  addItem = (evt) => {
    evt.preventDefault();
    const { list } = this.state;

    if (!this.state.title || !this.state.year) {
      this.setState({ error: 'Debe ingresar titulo y año.' });
      return;
    }

    const obj = {
      title: this.state.title,
      year: this.state.year,
    };

    if (this.state.edit === false) {
      list.push(obj);
    } else {
      list[this.state.index] = obj;
    }

    this.setState({
      list,
      edit: false,
      index: undefined,
      error: undefined,
      title: '',
      year: '',
    }, () => {
      this.props.onChange(this.state.list);
    });
  };

  removeItem = (evt, i) => {
    evt.preventDefault();
    const { list } = this.state;
    const index = list.indexOf(i);
    if (index > -1) {
      list.splice(index, 1);
    }

    this.setState({
      list,
    }, () => {
      this.props.onChange(this.state.list);
    });
  };

  showForm = (evt) => {
    evt.preventDefault();
    this.setState({ showForm: true });
  };

  hideForm = () => {
    this.setState({ showForm: false });
  };

  editItem = (evt, i) => {
    evt.preventDefault();
    const { list } = this.state;
    const index = list.indexOf(i);

    this.setState({
      index,
      showForm: true,
      edit: true,
      title: i.title,
      year: i.year,
    });
  };

  render() {
    const { showForm } = this.state;
    return (
      <Fragment>
        <div className={`achievements__wrapper ${showForm ? 'active' : ''}`}>
          {this.props.title && (
            <h2 className="heading">{this.props.title}</h2>
          )}
          <div className="form-group achievements" style={{ display: this.state.showForm ? 'flex' : 'none' }}>
            <div className="achievements__error">{this.state.error}</div>
            <div className="achievements__title">
              <label>Titulo</label>
              <input autoComplete="off" type="text" name="name" value={this.state.title} className="input-text" onChange={e => this.setState({ title: e.target.value })} />
            </div>
            <div className="achievements__dates">
              <div className="achievements__to">
                <label>Año</label>
                <div className="achievements__to-wrap">
                  <YearSelect
                    name="year"
                    placeholder="Año"
                    onChange={e => this.setState({ year: e && e.value })}
                    value={this.state.year}
                  />
                </div>
              </div>
            </div>
            <div className="achievements__add">
              <button className="btn-add" onClick={this.addItem}>
                {this.state.edit ? 'Editar' : 'Añadir'}
              </button>
              <button className="btn-cancel" onClick={this.hideForm}>
                Terminar
              </button>
            </div>
          </div>
          <div className="achievements__content">
            <ul className="achievements__list">
              {this.state.list.length === 0 && (
              <p className="achievements__not-added">{this.props.notAddedYet}</p>
            )}
              {this.state.list.map(i => (
                <li className="achievements__item" key={`${i.title}${i.year}`}>
                  <div className="achievements__description">
                    {i.title}
                  </div>
                  <div className="achievements__dates-values">
                    <span className="achievements__to-value">{i.year}</span>
                  </div>
                  <button className="achievements__item-remove" onClick={(e) => this.removeItem(e, i)}>
                    <i className="fa fa-times" />
                  </button>
                  <button className="achievements__item-edit" onClick={(e) => this.editItem(e, i)}>
                    <i className="fa fa-pencil" />
                  </button>
                </li>
            ))}
            </ul>
          </div>
          <button className="achievements__add-button" onClick={this.showForm} style={{ display: this.state.showForm ? 'none' : 'block' }}>
            <i className="fa fa-plus" aria-hidden="true" /> Añadir reconocimientos
          </button>
        </div>
      </Fragment>
    );
  }
}

Achievements.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
  notAddedYet: PropTypes.string,
};

Achievements.defaultProps = {
  title: undefined,
  onChange: () => {},
  notAddedYet: 'Aún no has añadido reconocimientos',
};

export default Achievements;



// WEBPACK FOOTER //
// ./src/components/Achievements/index.js